import httpClient from '@/services/http/httpClient'

export const apiGetTutorials = () => {
  return httpClient.get('/tutorials/')
    .then(data => data)
    .catch(error => Promise.reject(error))
}
